import { render, staticRenderFns } from "./AllMessage.vue?vue&type=template&id=4e69425e&scoped=true&"
import script from "./AllMessage.vue?vue&type=script&lang=js&"
export * from "./AllMessage.vue?vue&type=script&lang=js&"
import style0 from "./AllMessage.vue?vue&type=style&index=0&id=4e69425e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e69425e",
  null
  
)

export default component.exports